import { useContext } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import hocFrom from '../../../../components/forms/HocFrom';

import InputClock from '../../../../components/inputs/InputClock';
import InputControl from '../../../../components/inputs/InputControl';
import Loader from '../../../../components/layout/Loader';
import DashboardContext from '../../../../Context';

const FormWorkDay = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata, handleClose, handelcreate }) => {

    const { idview } = useContext(DashboardContext);

    const handelValue = (name, value) => {
        switch (name) {
            case 'dayOfWeek':
                handelsetdataForm({ ...formdata, dayOfWeek: value, workerId: JSON.parse(sessionStorage.getItem('workerId')) ? JSON.parse(sessionStorage.getItem('workerId')) : idview })
                break;
            case 'startTime':
                handelsetdataForm({ ...formdata, startTime: value })
                break;
            case 'endTime':
                handelsetdataForm({ ...formdata, endTime: value })
                break;
            default:
                break;
        }
    }


    const handelSubmit = (event) => {
        event.preventDefault()
        handelLoadingform(true)
        if (formdata.dayOfWeek === undefined) {
            toast.error("لطفا روز را انتخاب کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.startTime) {
            toast.error("لطفا ساعت شروع را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.endTime) {
            toast.error("لطفا ساعت پایان را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.dayOfWeek ? handelUpdataFrom() : handelSend()

            handelcreate()


        }
    }

    return (
        <>
            {
                loding ?
                    <Loader />
                    : <Form>
                        <Form.Row>
                            <Col>
                                <InputControl url='/workday/dayofweekdropdown' label='روزهای هفته' name='dayOfWeek' handelValue={handelValue} />
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <InputClock handelValue={handelValue} label='ساعت شروع'
                                    name='startTime' />
                            </Col>
                            <Col>
                                <InputClock handelValue={handelValue} label='ساعت پایان'
                                    name='endTime' />
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col className='d-flex' >
                                <Button variant="danger" onClick={handleClose} > بستن</Button>

                                <button type='submit'
                                    className='btn btn-success mr-auto'
                                    onClick={handelSubmit}
                                    disabled={LoadingForm}
                                >
                                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> :
                                        dataUpdate.dayOfWeek ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }
        </>
    );
}

export default hocFrom(FormWorkDay);
